import { RequestMainService } from "../request";

export class UploadService {
  static async singleUpload(params: any) {
    return RequestMainService.uploadFile("/upload/single", params, { timeout: 300000 }).then(
      (res) => res?.data?.result
    );
  }

}
